import { Component } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';
import './style.scss';

interface Props {
  isOpen: boolean;
  closeResetSuccesModal: () => void;
}

export default class ResetPasswordSuccesMessage extends Component<Props, {}> {
  render() {
    return (
      <CustomModalComponent isOpen={this.props.isOpen} onRequestClose={this.props.closeResetSuccesModal} className="reset-password-message ">
        <ModalBackground>
          <button className="d-flex flex-column align-items-center px-7 py-6 mx-auto" onClick={this.props.closeResetSuccesModal}>
            <Icon name={Icons.Email} size={86} className="color-mainblue" />
            <h3 className="family-regular text-size-18 text-uppercase letter-spacing-12 mt-6">{localeStore.t('check_your_mail')}</h3>
            <p className="reset-password-message__text family-semibold text-size-20 mt-3">{localeStore.t('we_have_sent_you_a_temporary_password')}</p>
          </button>
        </ModalBackground>
      </CustomModalComponent>
    );
  }
}
